import { render, staticRenderFns } from "./DesignRirekisho001Preview.vue?vue&type=template&id=f54c4de4&scoped=true&"
import script from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js&"
export * from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js&"
import style0 from "./DesignRirekisho001Preview.vue?vue&type=style&index=0&id=f54c4de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54c4de4",
  null
  
)

export default component.exports